<mat-sidenav-container style="background-color: #111315;"
    [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav style="background-color: #202427;" #rightSidenav mode="side" position="end">
        <app-assistant-container></app-assistant-container>
    </mat-sidenav>
</mat-sidenav-container>